"use client"; // safe even in Pages Router; ignored server-side
import { useEffect } from "react";

type Props = {
    /** Mute only in production by default */
    onlyInProd?: boolean;
    /** Also mute warn/error if true */
    muteWarnError?: boolean;
};

export default function ConsoleSilencer({
    onlyInProd = true,
    muteWarnError = false,
}: Props) {
    useEffect(() => {
        if (typeof window === "undefined") return;

        // If only mute in prod, skip in dev
        // if (onlyInProd && process.env.NODE_ENV !== "production") return;
        if (process.env.NEXT_PUBLIC_IS_LOCAL === "true") return;
        // URL override: ?debug=true or ?debug=1 keeps logs ON
        const params = new URLSearchParams(window.location.search);
        const debug = params.get("logs");
        if (debug === "true" || debug === "1") return;

        // Avoid double patching
        if ((window as any).__consolePatched) return;
        (window as any).__consolePatched = true;

        // Backup originals
        const orig = {
            log: console.log,
            info: console.info,
            debug: console.debug,
            trace: console.trace,
            warn: console.warn,
            error: console.error,
        };

        // Expose a restore hook for DevTools
        (window as any).__restoreConsole = () => {
            console.log = orig.log;
            console.info = orig.info;
            console.debug = orig.debug;
            console.trace = orig.trace;
            console.warn = orig.warn;
            console.error = orig.error;
        };

        // Mute selected methods
        console.log = () => {};
        console.info = () => {};
        console.debug = () => {};
        console.trace = () => {};
        if (muteWarnError) {
            console.warn = () => {};
            console.error = () => {};
        }
    }, [onlyInProd, muteWarnError]);

    return null;
}
